import React from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate  } from 'react-router-dom';
import Home from './components/Home/Home';
import About from './components/About/About';
import Projects from './components/Projects/Projects';
// import Blog from './components/Blog/Blog';
import Layout from './components/Layout/Layout';
import Contact from './components/Contact/Contact';

const App = () => {

  return (
    <Router>
      <Layout>
      <div className="App">        
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/projects" element={<Projects />} />
            <Route path="/contact" element={<Contact />} />
            {/* <Route path="/blog" element={<Blog />} /> */}
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
      </div>
      </Layout>
    </Router>
  );  
};

export default App;
